export default __webpack_public_path__ + "static/media/uploadIcon.9f2a64b4.svg";